<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .tab-content {
    display: grid;
    gap: utils.in_rem(20px);
    background-color: colors.get(interfaceWhite);
    border-radius: 0 utils.in_rem(10px) utils.in_rem(10px) utils.in_rem(10px);
    padding: utils.in_rem(16px) utils.in_rem(16px) utils.in_rem(20px)
      utils.in_rem(16px);

    &.full-page {
      border-radius: 0 0 utils.in_rem(10px) utils.in_rem(10px);
    }
  }

  .dropdowns {
    display: grid;
    gap: utils.in_rem(10px);
  }

  .section-title {
    @include mixins.h3();
  }

  .field-settings-placeholder {
    height: utils.in_rem(600px);
    margin: utils.in_rem(16px) 0;
  }

  .field-settings-container {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
  }

  /* Hide inactive tables */
  .hidden-table {
    display: none;
    visibility: hidden;
    height: 0;
    overflow: hidden;
  }

  .advanced-settings-container {
    margin-top: utils.in_rem(16px);
  }

  .status-wrapper {
    display: grid;
    margin-top: utils.in_rem(16px);
    gap: utils.in_rem(10px);
  }
</style>

<script>
  import AdvancedSettings from "../../../../components/shared/AdvancedSettings.svelte";
  import CustomTabs from "../../../../components/shared/CustomTabs.svelte";
  import SettingDropdown from "../../../../components/shared/SettingDropdown.svelte";
  import { integrationStore } from "../../../../stores";
  import AddingToProvider from "./AddingToProvider/AddingToProvider.svelte";
  import FieldSettingsTable from "./FieldSettingsTable/FieldSettingsTable.svelte";

  export let tabItems;
  export let toggleKeys;

  let currentType;

  const allTypes = tabItems.map((item) => item.kind);

  $: statusSettings = $integrationStore.getSettings("status", $currentType);
</script>

<CustomTabs {tabItems} bind:currentType />

<div class={tabItems.length < 4 ? "tab-content" : "tab-content full-page"}>
  <AddingToProvider type={$currentType} {toggleKeys} />

  <!-- Preload all tables but only show the active one. Doing this to save time on loading the table -->
  {#each allTypes as type}
    <div
      class:hidden-table={type !== $currentType}
      class:active-table={type === $currentType}
    >
      <FieldSettingsTable {type} />
    </div>
  {/each}

  {#if statusSettings.length}
    <div class="status-wrapper">
      <h3 class="section-title">
        {$currentType === "ClientContact" ? "Contact" : $currentType} status
      </h3>
      <div class="dropdowns">
        {#each statusSettings as setting}
          <SettingDropdown {setting} type={$currentType} />
        {/each}
      </div>
    </div>
  {/if}
  <div class="advanced-settings-container">
    <AdvancedSettings type={$currentType} section="contactAdvanced" />
  </div>
</div>
